import ProtvistaStructure from "./protvista-structure";

if (window.customElements) {
  customElements.define(ProtvistaStructure.is, ProtvistaStructure);
}
